import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router"

/**
 * useBackOrNavigate
 */

type Props = {
  alternativeRoute?: string;
};

export const useBackOrNavigate = () => {
  const navigate = useNavigate();

  const backFunction = useCallback(async (rota: string | number, options?: Props & NavigateOptions) => {
    if (typeof rota === 'string') {
      if (window.history.length > 0) {
        await navigate(rota, options);
      } else {
        await navigate(rota, options ?? { replace: true });
      }
    } else if (typeof rota === 'number') {
      if (window.history.length > 1) {
        await navigate(rota);
      } else {
        if (options && options.alternativeRoute) {
          await navigate(options?.alternativeRoute, { ...options, replace: true });
        }
      }
    }
  }, [navigate]);

  return backFunction;
}